import { TextField, InputAdornment } from '@mui/material';
import { useField } from 'formik';
import type { ChangeEventHandler, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TextFieldProps } from '../textInput/TextField.tsx';

export type CardExpirationInputProps = {
  name: string;
  value: string;
  onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  maxLength: number;
} & TextFieldProps;
const CardExpirationInput = (props: CardExpirationInputProps): ReactNode => {
  const { t } = useTranslation();
  const [cardExpirationInputField, , cardExpirationInputHelper] = useField(
    props.name,
  );

  const handleInputChange = (event) => {
    let value = event.target.value.replace(/\D/g, ''); // Remove non-digit characters
    const month = value.slice(0, 2);
    const year = value.slice(2, 4);

    value = `${month}${year}`;

    if (value.length > 2) {
      value = `${month}/${year}`;
    }

    event.target.value = value;
    cardExpirationInputHelper.setValue(value);
  };

  const getDataTestId = () => {
    if (!props.name) {
      return {};
    }

    return {
      'data-testid': props.name,
    };
  };

  return (
    <TextField
      value={cardExpirationInputField.value}
      onChange={handleInputChange}
      inputProps={{
        maxLength: 5,
        pattern: '\\d{2}/\\d{2}*',
        inputMode: 'numeric',
        ...getDataTestId(),
      }}
      required
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <span style={{ opacity: 0.5 }}>{t('MM/YY')}</span>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};

export default CardExpirationInput;
